import { render, staticRenderFns } from "./FilePreviewModal.vue?vue&type=template&id=50c4d0f4&scoped=true"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewModal.vue?vue&type=style&index=0&id=50c4d0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c4d0f4",
  null
  
)

export default component.exports